import { AssistentItem } from '../assistent_config';
import { MaschFzgElement } from './custom/MaschFzgElement';
import * as React from 'react';

export function getAssistentConfigMaschinenUndFahrzeuge(
    standort: any, data: any, onRoutingChange: (routing: any) => void, routing?: any
): AssistentItem {
    const element = (
        <MaschFzgElement
            data={data}
            onRoutingChange={onRoutingChange}
            routing={routing}
            standort={standort}
        />
    );
    const item = {
        gliederung: '8.',
        name: 'Technische Daten',
        description: '',
        type: 'CustomElement',
        infoTextKey: 'Geführter Modus - Technische Daten',
        customElements: [element],
        configFlag: 'inputTechnik'
    };
    return item;
}
